export enum FeedType {
  CRUMBLE = 'crumble',
  EXTRUDED = 'extruded',
  LIQUID = 'liquid',
  PELLET = 'pellet',
  SOY = 'soy',
}
